// eslint-disable-next-line
export const getRandomElsFromArray = (array: any, count: number) => array.sort(() => Math.random() - 0.5).slice(0, count);
